import { Box, Typography } from '@mui/material';

import { UnifiedAccount } from '../../../types/Account.interface';
import { accountTypeLabel } from '../../../ConnectStatements/components/InstitutionStatementCard';

import BankLogo from 'modules/HubV2/Bookkeeping/components/Banks2/BankList/Bank/BankLogo';
import bankAccountLabels from 'services/hurdlr/constants/bankAccountLabels';
import type { BankAccountSubType } from 'services/hurdlr/queries/useHurdlrPlaidItems/useHurdlrPlaidItems.interface';

interface AccountSummaryProps {
    account: UnifiedAccount;
    logoSize?: number;
}

/** A personal account's logo, name, type and last four. */
export default function AccountSummary({ account, logoSize = 40 }: Readonly<AccountSummaryProps>) {
    const typeLabel =
        (account.subtype && bankAccountLabels[account.subtype.toUpperCase() as BankAccountSubType]) ||
        accountTypeLabel(account.type);

    return (
        <Box sx={{ justifyContent: 'flex-start', alignItems: 'center', gap: 1, display: 'flex' }}>
            <BankLogo institutionId={account.institutionId} width={logoSize} height={logoSize} />
            <Box
                sx={{
                    alignSelf: 'stretch',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    display: 'inline-flex',
                }}>
                <Typography variant="body1" color="text.primary" fontWeight={500}>
                    {account.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {typeLabel} • {account.lastFour}
                </Typography>
            </Box>
        </Box>
    );
}
